import { LoadableAfterPaint } from '@confluence/loadable';
export {
	getBlankPageQuickActionsExperimentEnabled,
	getBPQAMilestone3ExperimentEnabled,
} from './getBlankPageQuickActionsExperimentEnabled';
export { useShouldShowBlankPageQuickActions } from './useShouldShowBlankPageQuickActions';
export { BlankPageQuickActionsProvider } from './BlankPageQuickActionsContext';
export { BlankPageQuickActionsTemplatePreview } from './BlankPageQuickActionsTemplatePreview';

export const BlankPageQuickActions = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-BlankPageQuickActions" */ './BlankPageQuickActions'
			)
		).BlankPageQuickActions,
});
